<template>
  <span class="beta-tag">
    {{ label }}
  </span>
</template>

<script>
export default {
  name: 'BetaTag',
  props: {
    label: {
      type: String,
      default: 'beta'
    }
  }
}
</script>

<style scoped>
.beta-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #f0f0f0;
  color: #6c6c6c;
  border: 1px solid #d9d9d9;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
